import { keyboardEvents } from '@argo/principles';
const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
export default (_ref => {
  let {
    overlayRef,
    onClose,
    focusOnContent
  } = _ref;
  const overlay = overlayRef.current;
  let firstFocusableElement = null;
  let focusHandler = () => {};
  if (overlay !== null) {
    const focusableContent = overlay.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1];
    if (focusOnContent) {
      firstFocusableElement = overlay;
    } else {
      [firstFocusableElement] = focusableContent;
    }
    focusHandler = e => {
      const pressedKey = e.key;
      const focusedElement = document.activeElement;
      if (![keyboardEvents.Escape, keyboardEvents.Tab].includes(pressedKey)) {
        return;
      }
      if (pressedKey === keyboardEvents.Escape) {
        return onClose();
      }
      switch (focusedElement) {
        case firstFocusableElement:
          {
            if (focusableContent.length === 1) {
              e.preventDefault();
            }
            if (e.shiftKey) {
              lastFocusableElement && lastFocusableElement.focus();
              e.preventDefault();
            }
            break;
          }
        case lastFocusableElement:
          {
            if (!e.shiftKey) {
              firstFocusableElement && firstFocusableElement.focus();
              e.preventDefault();
            }
            break;
          }
        default:
          {
            return;
          }
      }
    };
  }
  return {
    firstFocusableElement,
    focusHandler
  };
});
//# sourceMappingURL=useOverlayAccessibility.js.map